import {} from 'sp-office365-layout';

export const footer: any[] = [];
